import {put, call, takeLatest} from 'redux-saga/effects'
import {delay} from 'redux-saga'
import {initialize, arrayPush, arrayRemoveAll, reset, change} from 'redux-form'
import _ from 'lodash'
import moment from 'moment'

import {
  INVENTORY_TRANSFER_PAGE_REQUEST,
  INVENTORY_TRANSFER_TRANSFERS_REQUEST,
  INVENTORY_TRANSFER_ON_CLICK_ROW,
  INVENTORY_TRANSFER_ON_CHANGE_OUTLET_IDS,
  INVENTORY_TRANSFER_ON_CHANGE_DATE,
  INVENTORY_TRANSFER_ON_CLICK_CREATE_TRANSFER,
  INVENTORY_TRANSFER_GET_ITEMS,
  INVENTORY_TRANSFER_ON_MODAL_SELECT_CHANGE,
  INVENTORY_TRANSFER_ON_MODAL_ADD_ITEM,
  INVENTORY_TRANSFER_RESET_TRANSFERS_FORM,
  INVENTORY_TRANSFER_ON_SUBMIT_CREATE_TRANSFER_FORM,
  INVENTORY_TRANSFER_ON_CONFIRM_CREATE_TRANSFER,
  INVENTORY_TRANSFER_EXPORT,
  INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM,
  INVENTORY_TRANSFER_ON_NAMESPACE_CHANGE
} from 'actions/inventory/transfer/constants'

import * as actInvTrf from 'actions/inventory/transfer'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import * as actGetExportedFile from 'actions/get-exported-file'
import * as actLoadingSpinner from 'actions/loadingSpinner'
import {subscriptionStatus} from 'actions/inventory/ingredientSubscription'

import * as apiOutlets from 'api/outlets'
import * as apiProfile from 'api/profile'
import * as apiTrf from 'api/inventory/transfer'
import * as apiItem from 'api/items'
import * as apiCurrentInventory from 'api/currentInventoryDropdown'
import * as apiGetFilteredDate from 'api/get-filtered-date'
import * as apiUpdateFilteredDate from 'api/update-filtered-date'
import * as apiIngTrf from 'api/ingredientInventory/transfer'
import * as apiIngredients from 'api/ingredients'

import * as mpTransfers from 'mixpanel/inventory/transfer'

import {
  NAMESPACE_ITEMS,
  NAMESPACE_INGREDIENTS
} from 'actions/inventory/constants'

export function * pageRequest () {
  yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  // reset...
  yield put(actInvTrf.resetState())

  yield put(actInvTrf.setExportButtonStatus(false))

  yield put(act.showProgressBar())

  try {
    let respOutlets = yield call(apiOutlets.outlets)
    yield put(actInvTrf.setOutlets(respOutlets.data))

    let resProfile = yield call(apiProfile.getProfile)

    let resGetFilteredDate = yield call(apiGetFilteredDate.getFilteredDate)
    const startDate = moment(resGetFilteredDate.data.start_date)
    const endDate = moment(resGetFilteredDate.data.end_date)

    let resCurrentInventoryDropdown = yield call(apiCurrentInventory.getCurrentInventoryDropdown)
    const currentInventoryDropdown = resCurrentInventoryDropdown.data.current_inventory_dropdown

    yield put(initialize('search', {
      outletIds: resProfile.data.outlet_id,
      date: {startDate, endDate},
      namespace: currentInventoryDropdown
    }))

    yield call(setSelectedOutlets, respOutlets.data, resProfile.data.outlet_id)

    yield put(actInvTrf.transfersRequest({
      page: 1, start: startDate, end: endDate
    }, [], currentInventoryDropdown))

    yield put(reset('transferItem'))

    mpTransfers.inventoryTransferStart({
      outletIds: resProfile.data.outlet_id,
      startDate,
      endDate,
      namespace: currentInventoryDropdown
    })
    yield put(subscriptionStatus())
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actInvTrf.setExportButtonStatus(true))
  }
}

export function * transfersRequest (request) {
  const {payload: {params, previuosTransfers, namespace}} = request

  yield put(act.showProgressBar())

  try {
    let respTransfers = null
    if (namespace === NAMESPACE_ITEMS) {
      respTransfers = yield call(apiTrf.getTransfers, params)
    } else if (namespace === NAMESPACE_INGREDIENTS) {
      respTransfers = yield call(apiIngTrf.getTransfers, params)
    }

    const transfers = respTransfers.data.results
    // copy array
    const newTransfers = previuosTransfers.map(a => a)

    transfers.forEach((trf, index) => {
      const lastTransfer = newTransfers[newTransfers.length - 1]
      if (newTransfers.length === 0 || !moment(trf.created_at).isSame(moment(lastTransfer.created_at), 'days')) {
        newTransfers.push({
          created_at: trf.created_at,
          isdaterow: true
        })
      }
      newTransfers.push({
        ...trf,
        isdaterow: false
      })
    })
    yield put(actInvTrf.setTransfers(newTransfers))
    yield put(actInvTrf.setCurrentPage(params.page))
    yield put(actInvTrf.setTotalPage(respTransfers.data.total_pages))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actLoadingSpinner.showPageLoadingSpinner(false))
  }
}

export function * onClickRow (request) {
  const {payload: {transfer}} = request
  yield put(actInvTrf.setTransferDetail(transfer))
  yield put(actInvTrf.openRightColumn())
}

export function * onChangeOutletIdsFlow (request) {
  const {payload: {outletIds, startDate, endDate, namespace}} = request
  yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  // reset...
  yield put(actInvTrf.resetState())

  yield put(actInvTrf.setExportButtonStatus(false))

  yield put(act.showProgressBar())
  try {
    let respOutlets = yield call(apiOutlets.outlets)
    yield put(actInvTrf.setOutlets(respOutlets.data))

    yield call(apiOutlets.patchLogin, {id: outletIds})
    let resProfile = yield call(apiProfile.getProfile)
    yield call(setSelectedOutlets, respOutlets.data, resProfile.data.outlet_id)

    yield put(initialize('search', {
      outletIds,
      date: {startDate, endDate},
      namespace: namespace
    }))

    yield put(actInvTrf.transfersRequest({
      page: 1, start: moment(startDate).format('YYYY/MM/DD'), end: moment(endDate).format('YYYY/MM/DD')
    }, [], namespace))

    yield put(reset('transferItem'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actInvTrf.setExportButtonStatus(true))
  }
}

export function * onChangeDate (request) {
  const {payload: {startDate, endDate, namespace}} = request

  yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  // reset...
  yield put(actInvTrf.resetState())

  yield put(actInvTrf.setExportButtonStatus(false))

  yield put(act.showProgressBar())
  try {
    let respOutlets = yield call(apiOutlets.outlets)
    yield put(actInvTrf.setOutlets(respOutlets.data))

    let resProfile = yield call(apiProfile.getProfile)
    yield call(setSelectedOutlets, respOutlets.data, resProfile.data.outlet_id)

    yield call(apiUpdateFilteredDate.updateFilteredDate, {
      from: moment(startDate).format('D/M/YYYY'),
      to: moment(endDate).format('D/M/YYYY')
    })

    yield put(change('search', 'date', {startDate, endDate}))

    yield put(actInvTrf.transfersRequest({
      page: 1, start: moment(startDate).format('YYYY/MM/DD'), end: moment(endDate).format('YYYY/MM/DD')
    }, [], namespace))

    yield put(reset('transferItem'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actInvTrf.setExportButtonStatus(true))
  }
}

export function * onClickCreateTransfer (request) {
  const {payload: {outletIds}} = request
  yield put(actInvTrf.setTransferDetail(null))
  yield put(initialize('transferItem', {
    fromOutlet: outletIds.toString(),
    toOutlet: outletIds.toString(),
    transfers: []
  }))
  yield put(actInvTrf.openRightColumn())
}

export function * setSelectedOutlets (outlets, selectedOutlets) {
  let result = []
  if (selectedOutlets.length > 1) {
    yield put(actInvTrf.setSelectedOutlets(outlets))
  } else {
    outlets.forEach((outlet, index) => {
      if (outlet.id === selectedOutlets[0]) {
        result.push(outlet)
      }
    })
    yield put(actInvTrf.setSelectedOutlets(result))
  }
}

export function * getItems (request) {
  yield put(actInvTrf.setItemsOptionIsLoading(true))

  const {payload: {fromOutletId, keyword, page, namespace, isInit, isGetFromInit, previousAddItems, previousTotalPage, initData}} = request
  const perPage = 100

  let itemOptions = []
  // let items = []
  let respItems = null
  let searchItemsdata = null
  let currentPage
  let totalPage = previousTotalPage

  try {
    if (isGetFromInit) {
      if (initData) {
        let data = {data: initData}
        respItems = data
      }
    } else {
      if (keyword) {
        yield call(delay, 300)
      }
      if (namespace === NAMESPACE_ITEMS) {
        respItems = yield call(apiItem.getItemsV1
          , {
            outlet_id: fromOutletId,
            no_categories: true,
            keyword: keyword,
            page: page,
            per_page: perPage
          })
      } else if (namespace === NAMESPACE_INGREDIENTS) {
        respItems = yield call(apiIngredients.getAll, {
          outlet_id: fromOutletId,
          no_categories: true,
          keyword: keyword,
          page: page,
          per_page: perPage
        })
      }
    }

    searchItemsdata = respItems.data

    if (page > 1) {
      if (searchItemsdata.length > 0) {
        totalPage = page
      }
      currentPage = page
    } else {
      currentPage = 1
      totalPage = 1
    }

    searchItemsdata = previousAddItems.concat(searchItemsdata)

    searchItemsdata.forEach((item, index) => {
      itemOptions.push({value: item.id, label: item.name})
    })

    if (isInit) {
      yield put(actInvTrf.setSearchItemsInit({items: searchItemsdata, itemOptions: itemOptions, currentPage: currentPage, totalPage: totalPage}))
    }

    yield put(actInvTrf.setAddItems({items: searchItemsdata, itemOptions: itemOptions, currentPage: currentPage, totalPage: totalPage}))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(actInvTrf.setItemsOptionIsLoading(false))
  }
}

export function * formOnClickAddItems () {
  yield put(initialize('addTransferItems', {items: []}))
}

export function * onModalSelectChange (request) {
  const {payload: {selectedItemId, items, transfers, namespace}} = request

  if (selectedItemId === undefined) {
    yield put(initialize('addTransferItems', {
      items: []
    }))
    return
  }

  let isItemFound = false

  yield put(initialize('addTransferItems', {items: []}))
  yield put(actInvTrf.setIsItemAlreadyAdded(false))

  if (transfers.length) {
    transfers.forEach((trf, index) => {
      if (namespace === NAMESPACE_ITEMS && trf.itemId === selectedItemId) {
        isItemFound = true
      }
      if (namespace === NAMESPACE_INGREDIENTS && trf.ingredientId === selectedItemId) {
        isItemFound = true
      }
    })
  }

  if (!transfers.length || !isItemFound) {
    let temporaryItem = _.find(items, {'id': selectedItemId})

    let fields = []
    if (namespace === NAMESPACE_ITEMS) {
      temporaryItem.item_variants.forEach((iv, index) => {
        if (!iv.is_deleted) {
          fields.push({
            isItem: temporaryItem.item_variants.length === 1,
            itemId: temporaryItem.id,
            itemName: temporaryItem.name,
            itemIsRecipe: temporaryItem.is_recipe,
            itemVariantId: iv.id,
            itemVariantName: iv.name,
            inStock: iv.in_stock,
            quantity: 0,
            sku: iv.sku,
            price: iv.price
          })
        }
      })
    } else if (namespace === NAMESPACE_INGREDIENTS) {
      fields.push({
        ingredientId: temporaryItem.id,
        ingredientName: temporaryItem.name,
        unitId: temporaryItem.unit_id,
        unitName: temporaryItem.unit_name,
        inStock: temporaryItem.in_stock,
        quantity: 0
      })
    }

    // yield put(initialize('addTransferItems', {
    //   items: fields
    // }))
    for (let i = 0; i < fields.length; i++) {
      yield put(arrayPush('addTransferItems', 'items', fields[i]))
    }
  } else {
    yield put(actInvTrf.setIsItemAlreadyAdded(true))
  }
}

export function * onModalAddItem (request) {
  // const {payload: {items, transfers}} = request
  const {payload: {items}} = request

  // let oldTransfers = transfers.slice(0)
  // let newTransfers = []
  // let isFound = false
  // let isPushed = false
  //
  // items.forEach((item, index) => {
  //   if (oldTransfers.length === 0) {
  //     newTransfers.push(item)
  //     isPushed = true
  //   } else {
  //     oldTransfers.forEach((trf, index) => {
  //       if (trf.itemId === item.itemId && trf.itemVariantId === item.itemVariantId) {
  //         trf.quantity = parseInt(trf.quantity.toString()) + parseInt(item.quantity.toString())
  //         isFound = true
  //       }
  //     })
  //   }
  //
  //   if (!isFound && !isPushed) {
  //     newTransfers.push(item)
  //   }
  //
  //   isFound = false
  //   isPushed = false
  // })

  // yield put(arrayRemoveAll('transferItem', 'transfers'))

  // for (let i = 0; i < oldTransfers.length; i++) {
  //   yield put(arrayPush('transferItem', 'transfers', oldTransfers[i]))
  // }
  //
  // for (let i = 0; i < newTransfers.length; i++) {
  //   yield put(arrayPush('transferItem', 'transfers', newTransfers[i]))
  // }

  for (let i = 0; i < items.length; i++) {
    yield put(arrayPush('transferItem', 'transfers', items[i]))
  }

  yield put(actInvTrf.closeAddItemModal())
}

export function * resetTransfersForm () {
  yield put(arrayRemoveAll('transferItem', 'transfers'))
}

export function * onSubmitCreateTransferForm (request) {
  const {payload: {values}} = request
  let hasError = false

  if (values.fromOutlet === null || values.fromOutlet === '') {
    yield put(actNotif.error('Please choose from outlet'))
    hasError = true
  }
  if (values.toOutlet === null || values.toOutlet === '') {
    yield put(actNotif.error('Please choose to outlet'))
    hasError = true
  }
  if (values.transfers.length === 0) {
    yield put(actNotif.error('Please add Transfer Stock before saving'))
    hasError = true
  }
  if (values.fromOutlet === values.toOutlet) {
    yield put(actNotif.error('Destination outlet must be different from origin outlet'))
    hasError = true
  }

  if (values.transfers.length) {
    let total = 0
    values.transfers.forEach((trf, index) => {
      total = total + parseFloat(trf.quantity)
    })
    if (total <= 0) {
      yield put(actNotif.error('Total transfer must be greater than 0'))
      hasError = true
    }
  }

  if (!hasError) {
    yield put(actInvTrf.setShowConfirmSubmitModal(true))
  }
}

export function * onConfirmCreateTransfer (request) {
  const {payload: {values, date, namespace}} = request

  yield put(actInvTrf.setConfirmCreateButtonStatus(true))

  let total = 0
  let transferData = null

  if (namespace === NAMESPACE_ITEMS) {
    transferData = {
      from_outlet_id: parseInt(values.fromOutlet),
      outlet_id: parseInt(values.fromOutlet),
      to_outlet_id: parseInt(values.toOutlet),
      total: '',
      history_details: [],
      history_details_attributes: [],
      note: values.notes ? values.notes : ''
    }

    values.transfers.forEach((trf, index) => {
      if (trf.quantity > 0) {
        let details = {
          beginning_stock: trf.inStock,
          end_stock: trf.inStock - parseInt(trf.quantity),
          item_id: trf.itemId,
          item_variant_id: trf.itemVariantId,
          item_variant_name: trf.itemVariantName ? trf.itemVariantName : trf.itemName,
          name: trf.itemName,
          quantity: trf.quantity
        }

        transferData.history_details.push(details)
        transferData.history_details_attributes.push(details)

        total = total + parseInt(trf.quantity)
      }
    })

    transferData.total = total
  } else if (namespace === NAMESPACE_INGREDIENTS) {
    transferData = {
      from_outlet_id: parseInt(values.fromOutlet),
      outlet_id: parseInt(values.fromOutlet),
      to_outlet_id: parseInt(values.toOutlet),
      history_details: [],
      history_details_attributes: [],
      note: values.notes ? values.notes : '',
      outlet_receiver_id: parseInt(values.toOutlet),
      outlet_sender_id: parseInt(values.fromOutlet)
    }

    values.transfers.forEach((trf, index) => {
      if (trf.quantity > 0) {
        let details = {
          beginning_stock: trf.inStock,
          end_stock: trf.inStock - parseFloat(trf.quantity),
          ingredient_id: trf.ingredientId,
          ingredient_name: trf.ingredientName,
          quantity: trf.quantity,
          unit_id: trf.unitId,
          unit_name: trf.unitName
        }

        transferData.history_details.push(details)
        transferData.history_details_attributes.push(details)
      }
    })
  }

  try {
    yield put(act.showProgressBar())

    let resTransfer = {}
    if (namespace === NAMESPACE_ITEMS) {
      resTransfer = yield call(apiTrf.postTransfers, {transfer: transferData})
    } else if (namespace === NAMESPACE_INGREDIENTS) {
      resTransfer = yield call(apiIngTrf.postTransfers, {ingredient_transfer: transferData})
    }

    yield put(reset('transferItem'))
    yield put(actNotif.success(resTransfer.data.success_msg))
    if (!moment().isBetween(date.startDate, date.endDate, 'day', '[]')) {
      yield call(apiUpdateFilteredDate.updateFilteredDate, {
        from: moment().format('D/M/YYYY'),
        to: moment().format('D/M/YYYY')
      })
    }

    mpTransfers.inventoryTransferCreate({
      outletFromName: transferData.from_outlet_id,
      outletToName: transferData.to_outlet_id,
      namespace,
      items: transferData.history_details
    })

    yield call(pageRequest)
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actInvTrf.setShowConfirmSubmitModal(false))
    yield put(actInvTrf.setConfirmCreateButtonStatus(false))
  }
}

export function * exportTransfer (request) {
  const {payload: {date, filename, outletId, namespace}} = request

  try {
    if (namespace === NAMESPACE_ITEMS) {
      yield call(apiTrf.getExportTransfer, date)
      yield put(actGetExportedFile.getExportedFile(filename, outletId, 'Inventory Transfer'))
    } else if (namespace === NAMESPACE_INGREDIENTS) {
      yield call(apiIngTrf.getExportTransfer, date)
      yield put(actGetExportedFile.getExportedFile(filename, outletId, 'Ingredient Inventory Transfer'))
    }
  } catch (error) {
    yield put(actNotif.error(error.message))
  }
}

export function * onNamespaceChange (request) {
  const {payload: {namespace}} = request

  yield put(actLoadingSpinner.showPageLoadingSpinner(true))
  // reset...
  yield put(actInvTrf.resetState())
  yield put(actInvTrf.setExportButtonStatus(false))

  yield put(act.showProgressBar())

  try {
    let respOutlets = yield call(apiOutlets.outlets)
    yield put(actInvTrf.setOutlets(respOutlets.data))

    let resProfile = yield call(apiProfile.getProfile)

    let resGetFilteredDate = yield call(apiGetFilteredDate.getFilteredDate)
    const startDate = moment(resGetFilteredDate.data.start_date)
    const endDate = moment(resGetFilteredDate.data.end_date)

    yield call(apiCurrentInventory.putCurrentInventoryDropdown, {current_inventory_dropdown: namespace})

    yield put(initialize('search', {
      outletIds: resProfile.data.outlet_id,
      date: {startDate, endDate},
      namespace: namespace
    }))

    yield call(setSelectedOutlets, respOutlets.data, resProfile.data.outlet_id)

    yield put(actInvTrf.transfersRequest({
      page: 1, start: startDate, end: endDate
    }, [], namespace))

    yield put(reset('transferItem'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
    yield put(actInvTrf.setExportButtonStatus(true))
  }
}

export default function * saga () {
  yield takeLatest(INVENTORY_TRANSFER_PAGE_REQUEST, pageRequest)
  yield takeLatest(INVENTORY_TRANSFER_TRANSFERS_REQUEST, transfersRequest)
  yield takeLatest(INVENTORY_TRANSFER_ON_CLICK_ROW, onClickRow)
  yield takeLatest(INVENTORY_TRANSFER_ON_CHANGE_OUTLET_IDS, onChangeOutletIdsFlow)
  yield takeLatest(INVENTORY_TRANSFER_ON_CHANGE_DATE, onChangeDate)
  yield takeLatest(INVENTORY_TRANSFER_ON_CLICK_CREATE_TRANSFER, onClickCreateTransfer)
  yield takeLatest(INVENTORY_TRANSFER_GET_ITEMS, getItems)
  yield takeLatest(INVENTORY_TRANSFER_ON_MODAL_SELECT_CHANGE, onModalSelectChange)
  yield takeLatest(INVENTORY_TRANSFER_ON_MODAL_ADD_ITEM, onModalAddItem)
  yield takeLatest(INVENTORY_TRANSFER_RESET_TRANSFERS_FORM, resetTransfersForm)
  yield takeLatest(INVENTORY_TRANSFER_ON_SUBMIT_CREATE_TRANSFER_FORM, onSubmitCreateTransferForm)
  yield takeLatest(INVENTORY_TRANSFER_ON_CONFIRM_CREATE_TRANSFER, onConfirmCreateTransfer)
  yield takeLatest(INVENTORY_TRANSFER_EXPORT, exportTransfer)
  yield takeLatest(INVENTORY_TRANSFER_ON_CLICK_ADD_ITEM, formOnClickAddItems)
  yield takeLatest(INVENTORY_TRANSFER_ON_NAMESPACE_CHANGE, onNamespaceChange)
}



// WEBPACK FOOTER //
// ./app/sagas/inventory/transfer.js